import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isType',
  standalone: true,
})
export class IsTypePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, type: 'string' | 'number' | 'object' | 'boolean' | 'function' | 'undefined' | 'array'): boolean {
    if (type === 'array') {
      return Array.isArray(value);
    }

    return typeof value === type;
  }
}
